class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm6 6.5h-3a12.13 12.13 0 0 0-1.395-5.275A6 6 0 0 1 14 7.5ZM8 14a2.497 2.497 0 0 1-.335 0A10.925 10.925 0 0 1 6 8.5h4A10.925 10.925 0 0 1 8.35 14 2.493 2.493 0 0 1 8 14ZM6 7.5c.05-1.948.62-3.847 1.65-5.5a3 3 0 0 1 .67 0A10.925 10.925 0 0 1 10 7.5H6Zm.38-5.275A12.13 12.13 0 0 0 5 7.5H2a6 6 0 0 1 4.395-5.275H6.38ZM2.025 8.5h3A12.13 12.13 0 0 0 6.4 13.775 6 6 0 0 1 2.025 8.5Zm7.58 5.275A12.13 12.13 0 0 0 11 8.5h3a6 6 0 0 1-4.395 5.275Z" clip-rule="evenodd"></path></svg>';
  }
}
const e = "pi-globe";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
